
import { Navigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isAuthLoading } = useAppContext();
  if (isAuthLoading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/home" />;
  }
  return children;
};

export default ProtectedRoute;
